// Descriptions of the 41 studio gallery photos, in file order (studio-image01
// ... studio-image41). Each one describes only what is visible in the photo.
const DESCRIPTIONS = [
  "Couple in pink and black outfits embracing in a studio portrait",
  "Girl in a purple tulle ball gown in a studio portrait",
  "Smiling woman in glasses with her hand under her chin",
  "Maternity portrait of a couple in colourful tropical-print outfits against a green backdrop",
  "Woman in a turquoise dress posing beside a large illuminated marquee number",
  "Couple in black outfits and white boots posing against a green backdrop",
  "Woman in a hat and glasses against a teal backdrop",
  "Woman in a traditional gele headwrap and coral beads against a brown backdrop",
  "Studio portrait of a woman in a black blazer",
  "Two women laughing together while lying on a fur rug",
  "Maternity photo of a couple posing with white blocks against a green backdrop",
  "Maternity portrait of a couple with the expectant mother's bump",
  "Woman seated cross-legged on a fur rug in a pink t-shirt and jeans",
  "Woman in a white shirt and flared jeans seated on white blocks",
  "Boy in a black suit and pink shirt against a green backdrop",
  "Woman in a wide-brim black hat and sunglasses",
  "Family portrait of parents and children in casual outfits",
  "Woman in a purple satin headscarf and sunglasses",
  "Man in a white sleeveless outfit and hat seated on a white block",
  "Woman in sunglasses and a black and white outfit seated on a block",
  "Couple in navy outfits embracing in a studio portrait",
  "Maternity portrait of a woman holding her bump in a black top",
  "Woman in a white lace outfit holding a black hat",
  "Woman in a white lace outfit and black hat",
  "Seated portrait of a woman in a gele headwrap and traditional attire",
  "Man in traditional striped attire against a green backdrop",
  "Family portrait in coordinated pink and black outfits",
  "Boy in a brown jacket and flat cap seated on a flight case",
  "Woman in a pink headwrap and floral lace outfit against a golden backdrop",
  "Woman in an orange sequin dress against a brown backdrop",
  "Boy in a brown jacket and white shirt standing in a studio portrait",
  "Woman in traditional attire and a headwrap against a brown backdrop",
  "Woman seated on a fur rug in a pink t-shirt and jeans",
  "Two young boys in matching navy waistcoats, one on a wooden stool",
  "Family in matching traditional striped outfits and headwraps against a green backdrop",
  "Family seated together on a fur rug",
  "Girl in sunglasses seated on a black chair against a grey backdrop",
  "Woman in a magenta top with long wavy hair",
  "Family in matching sports shirts",
  "Family with children in pink outfits",
  "Couple with two young children in navy outfits",
];

export const STUDIO_IMAGE_ALTS = DESCRIPTIONS.map(
  (text) => `${text} at Kinews Studio Rochdale`,
);

export const studioImageAlt = (index) =>
  STUDIO_IMAGE_ALTS[index] || "Studio photography session at Kinews Studio Rochdale";
